/* Sibia theme: product page behavior (variants, gallery, zoom, delivery estimate, packs, sticky bar, share) */
(function () {
  'use strict';

  var config = window.themeConfig || {};
  var strings = config.strings || {};

  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); }

  function initProduct(root) {
    if (!root || root.dataset.productInit) { return; }
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) { return; }
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.productInit = '1';

    var variants = data.variants || [];
    var picker = $('[data-variant-picker]', root);
    var idInputs = $$('[data-variant-id]', root);
    var gallery = $('[data-gallery]', root);

    /* Gallery ------------------------------------------------------------ */
    var goToSlide = function () {};
    var showMedia = function () {};

    if (gallery) {
      var track = $('[data-gallery-track]', gallery);
      var slides = $$('.pgallery__slide', track);
      var thumbs = $$('[data-thumb-index]', gallery);
      var thumbsEl = $('[data-gallery-thumbs]', gallery);
      var dots = $$('.pgallery__dot', gallery);
      var current = 0;

      var setActive = function (i) {
        current = i;
        thumbs.forEach(function (thumb, n) { thumb.classList.toggle('is-active', n === i); });
        dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
        var thumb = thumbs[i];
        if (thumb && thumbsEl) {
          if (thumbsEl.scrollHeight > thumbsEl.clientHeight + 2) {
            thumbsEl.scrollTo({ top: thumb.offsetTop - thumbsEl.clientHeight / 2 + thumb.clientHeight / 2, behavior: 'smooth' });
          } else if (thumbsEl.scrollWidth > thumbsEl.clientWidth + 2) {
            thumbsEl.scrollTo({ left: thumb.offsetLeft - thumbsEl.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
          }
        }
      };

      goToSlide = function (i, instant) {
        if (!track || !slides.length) { return; }
        var target = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: target * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        setActive(target);
      };

      showMedia = function (mediaId) {
        if (mediaId === null || mediaId === undefined) { return; }
        for (var n = 0; n < slides.length; n++) {
          if (String(slides[n].getAttribute('data-media-id')) === String(mediaId)) {
            goToSlide(n);
            return;
          }
        }
      };

      var ticking = false;
      if (track) {
        track.addEventListener('scroll', function () {
          if (ticking) { return; }
          ticking = true;
          window.requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (i !== current) { setActive(i); }
            ticking = false;
          });
        }, { passive: true });
        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); goToSlide(current + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); goToSlide(current - 1); }
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToSlide(parseInt(thumb.getAttribute('data-thumb-index'), 10));
        });
      });

      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (prev) { prev.addEventListener('click', function () { goToSlide(current <= 0 ? slides.length - 1 : current - 1); }); }
      if (next) { next.addEventListener('click', function () { goToSlide(current >= slides.length - 1 ? 0 : current + 1); }); }

      /* Lightbox */
      if (gallery.getAttribute('data-lightbox') === 'true') {
        gallery.addEventListener('click', function (event) {
          var trigger = event.target.closest ? event.target.closest('[data-lightbox-open]') : null;
          if (!trigger) { return; }
          var urls = [];
          var start = 0;
          slides.forEach(function (slide) {
            var button = $('[data-lightbox-open]', slide);
            if (button) {
              if (button === trigger) { start = urls.length; }
              urls.push(button.getAttribute('data-full'));
            }
          });
          openLightbox(urls, start);
        });
      }
    }

    function openLightbox(urls, startIndex) {
      if (!urls.length) { return; }
      var index = startIndex;
      var overlay = document.createElement('div');
      overlay.className = 'lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Image viewer');

      var img = document.createElement('img');
      img.alt = '';
      overlay.appendChild(img);

      function makeButton(className, label, svgPath) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'lightbox__btn ' + className;
        button.setAttribute('aria-label', label);
        button.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + svgPath + '"/></svg>';
        return button;
      }

      var closeBtn = makeButton('lightbox__close', 'Close', 'M6 6l12 12M18 6L6 18');
      overlay.appendChild(closeBtn);
      var prevBtn = null;
      var nextBtn = null;
      if (urls.length > 1) {
        prevBtn = makeButton('lightbox__prev', 'Previous image', 'M15 5l-7 7 7 7');
        nextBtn = makeButton('lightbox__next', 'Next image', 'M9 5l7 7-7 7');
        overlay.appendChild(prevBtn);
        overlay.appendChild(nextBtn);
      }

      function render() { img.src = urls[index]; }
      function step(delta) { index = (index + delta + urls.length) % urls.length; render(); }
      function close() {
        document.removeEventListener('keydown', onKey);
        if (overlay.parentNode) { overlay.parentNode.removeChild(overlay); }
        document.body.classList.remove('no-scroll');
      }
      function onKey(event) {
        if (event.key === 'Escape') { close(); }
        if (event.key === 'ArrowRight' && urls.length > 1) { step(1); }
        if (event.key === 'ArrowLeft' && urls.length > 1) { step(-1); }
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) { close(); }
      });
      closeBtn.addEventListener('click', close);
      if (prevBtn) { prevBtn.addEventListener('click', function () { step(-1); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { step(1); }); }
      document.addEventListener('keydown', onKey);

      render();
      document.body.appendChild(overlay);
      document.body.classList.add('no-scroll');
      closeBtn.focus();
    }

    /* Variants ----------------------------------------------------------- */
    function getSelectedOptions() {
      if (!picker) { return variants.length ? variants[0].options.slice() : []; }
      return $$('[data-option-index]', picker).map(function (fieldset) {
        var checked = $('[data-option-input]:checked', fieldset);
        if (checked) { return checked.value; }
        var select = $('[data-option-select]', fieldset);
        return select ? select.value : null;
      });
    }

    function findVariant(options) {
      for (var n = 0; n < variants.length; n++) {
        var variant = variants[n];
        var match = true;
        for (var i = 0; i < variant.options.length; i++) {
          if (variant.options[i] !== options[i]) { match = false; break; }
        }
        if (match) { return variant; }
      }
      return null;
    }

    function findVariantById(id) {
      for (var n = 0; n < variants.length; n++) {
        if (String(variants[n].id) === String(id)) { return variants[n]; }
      }
      return null;
    }

    function updateOptionAvailability(options) {
      if (!picker) { return; }
      $$('[data-option-index]', picker).forEach(function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-index'), 10);
        $$('[data-option-input]', fieldset).forEach(function (input) {
          var candidate = options.slice();
          candidate[position] = input.value;
          var variant = findVariant(candidate);
          input.classList.toggle('is-unavailable', !variant || !variant.available);
        });
        var label = $('[data-option-selected]', fieldset);
        if (label && options[position] !== undefined) { label.textContent = options[position]; }
      });
    }

    function setText(selector, text) {
      $$(selector, root).forEach(function (el) { el.textContent = text; });
    }

    function updateStock(variant) {
      $$('[data-stock]', root).forEach(function (el) {
        var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 10;
        var textEl = $('[data-stock-text]', el);
        var fill = $('[data-stock-fill]', el);
        if (variant && variant.available && variant.inventory !== null && variant.inventory > 0 && variant.inventory <= threshold) {
          var template = el.getAttribute('data-template') || '{count}';
          if (textEl) { textEl.textContent = template.replace('{count}', variant.inventory); }
          if (fill) { fill.style.width = Math.max(6, Math.round((variant.inventory / threshold) * 100)) + '%'; }
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    }

    function updateButtons(variant) {
      $$('[data-atc-button]', root).forEach(function (button) {
        var label = $('[data-atc-label]', button);
        var canBuy = !!(variant && variant.available);
        button.disabled = !canBuy;
        if (label) {
          if (!variant) { label.textContent = strings.unavailable || 'Unavailable'; }
          else if (variant.available) { label.textContent = button.getAttribute('data-add-label') || strings.addToCart || 'Add to cart'; }
          else { label.textContent = button.getAttribute('data-soldout-label') || strings.soldOut || 'Sold out'; }
        }
      });
      var sticky = $('[data-sticky-submit]', root);
      if (sticky) {
        sticky.disabled = !(variant && variant.available);
        setText('[data-sticky-label]', !variant ? (strings.unavailable || 'Unavailable') : (variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out')));
      }
    }

    function updatePrice(variant) {
      if (!variant) { return; }
      setText('[data-price-current]', variant.price);
      setText('[data-sticky-price]', variant.price);
      $$('[data-price-compare]', root).forEach(function (el) {
        el.textContent = variant.compare;
        el.hidden = !variant.onSale;
      });
      $$('[data-price-off]', root).forEach(function (el) {
        el.textContent = variant.percent + '% OFF';
        el.hidden = !variant.onSale;
      });
      $$('[data-price-savings]', root).forEach(function (el) {
        el.textContent = 'You save ' + variant.savings;
        el.hidden = !variant.onSale;
      });
    }

    function applyVariant(variant, initial) {
      idInputs.forEach(function (input) { input.value = variant ? variant.id : ''; });
      updatePrice(variant);
      updateButtons(variant);
      updateStock(variant);
      if (variant && !initial) {
        showMedia(variant.mediaId);
        if (root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    function onOptionChange() {
      var options = getSelectedOptions();
      updateOptionAvailability(options);
      applyVariant(findVariant(options), false);
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('[data-option-input], [data-option-select]')) { onOptionChange(); }
    });

    var initialVariant = findVariantById(data.selectedVariantId);
    updateOptionAvailability(getSelectedOptions());
    applyVariant(initialVariant, true);

    /* Pack selector ------------------------------------------------------ */
    var qtyField = $('[data-buy-qty]', root);
    var packInputs = $$('[data-pack-input]', root);
    function setQuantity(value) {
      if (!qtyField) { return; }
      qtyField.value = value;
    }
    packInputs.forEach(function (radio) {
      radio.addEventListener('change', function () { setQuantity(radio.value); });
      if (radio.checked) { setQuantity(radio.value); }
    });
    if (qtyField && packInputs.length) {
      qtyField.addEventListener('change', function () {
        var matched = false;
        packInputs.forEach(function (radio) {
          var same = String(radio.value) === String(qtyField.value);
          radio.checked = same && !matched;
          if (same) { matched = true; }
        });
      });
    }

    /* Delivery estimate -------------------------------------------------- */
    $$('[data-delivery]', root).forEach(function (el) {
      var input = $('[data-delivery-input]', el);
      var button = $('[data-delivery-check]', el);
      var output = $('[data-delivery-result]', el);
      if (!input || !button || !output) { return; }
      var length = parseInt(el.getAttribute('data-length'), 10) || 6;
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || 7);
      var pattern = new RegExp('^\\d{' + length + '}$');

      function formatDate(date) {
        try {
          return date.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
        } catch (e) {
          return date.toDateString();
        }
      }

      function check() {
        var value = input.value.replace(/\s+/g, '');
        output.hidden = false;
        if (!pattern.test(value)) {
          output.textContent = el.getAttribute('data-error-text') || '';
          output.classList.add('is-error');
          return;
        }
        var start = new Date();
        var end = new Date();
        start.setDate(start.getDate() + min);
        end.setDate(end.getDate() + max);
        var template = el.getAttribute('data-result-template') || '{start} - {end}';
        output.textContent = template.replace('{start}', formatDate(start)).replace('{end}', formatDate(end));
        output.classList.remove('is-error');
        try { localStorage.setItem('theme_pincode', value); } catch (e) {}
      }

      button.addEventListener('click', check);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); check(); }
      });

      try {
        var saved = localStorage.getItem('theme_pincode');
        if (saved && !input.value && pattern.test(saved)) {
          input.value = saved;
          check();
        }
      } catch (e) {}
    });

    /* Sticky add to cart ------------------------------------------------- */
    var sticky = $('[data-sticky-atc]', root);
    var buyForm = $('[data-product-form]', root);
    if (sticky && buyForm) {
      var anchor = $('[data-atc-button]', buyForm) || buyForm;
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }, { threshold: 0 });
        observer.observe(anchor);
      }
      var stickyButton = $('[data-sticky-submit]', sticky);
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (buyForm.requestSubmit) { buyForm.requestSubmit(); }
          else { var submit = $('[data-atc-button]', buyForm); if (submit) { submit.click(); } }
        });
      }
    }

    /* Share -------------------------------------------------------------- */
    $$('[data-share]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-url');
        var title = button.getAttribute('data-title');
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        var label = $('[data-share-label]', button);
        var original = label ? label.textContent : '';
        var done = function () {
          if (label) {
            label.textContent = button.getAttribute('data-copied-label') || 'Link copied';
            setTimeout(function () { label.textContent = original; }, 2000);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        }
      });
    });
  }

  function initAll(context) {
    $$('[data-product-section]', context).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
